var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"magnifier",style:({
            width: (_vm.size + "vw"),
            height: (_vm.size + "vw"),
            position: _vm.absolute ? 'absolute' : 'relative'
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }